module.exports = __webpack_public_path__ + "static/media/koinworx.14225466.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/koinworx.webp
// module id = 711
// module chunks = 0